<template>
    <div class="coupon">
        <el-row style="margin-top:20px;">
            <el-col :span="24">
                <el-card class="box-card">
                    <el-row :gutter="15">
                        <el-col :span="1.2"
                            ><div class="grid-content bg-purple">
                                <span>专题名称:</span>
                            </div></el-col
                        >
                        <el-col :span="5"
                            ><div class="grid-content bg-purple">
                                <el-input v-model.trim="searchInfo.topicName" placeholder="请输入专题名称" clearable></el-input></div
                        ></el-col>
                        <el-col :span="15">
                            <el-button type="primary" icon="el-icon-search" @click="Search()">查询</el-button>
                             <el-button type="primary" icon="el-icon-plus" @click="addModal">新增</el-button>
                            <el-button type="primary" icon="el-icon-back" @click="goBack()">返回列表</el-button>
                        </el-col>
                    </el-row>
                    <el-table :data="tableData" style="width: 100%" border>
                        <el-table-column :resizable="false" type="index" label="序号" width="50">
                                <template slot-scope="scope">{{ scope.$index + 1 + searchInfo.pageSize * (searchInfo.pageNum - 1) }}</template>
                        </el-table-column>
                        <el-table-column :resizable="false" prop="topicName" label="专题名称" align="center"></el-table-column>
                        <el-table-column prop="createTime" label="提交时间" :resizable="false" align="center">
                            <template slot-scope="scope">
                                <span>{{ scope.row.createTime | moment('YYYY-MM-DD HH:mm:ss') }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" :resizable="false" align="center">
                            <template slot-scope="scope">
                                <el-button  @click="editModal(scope.row)" type="text" size="small">修改</el-button>
                                <el-button @click="checkModal(scope.row)" type="text" size="small">查看</el-button>
                                <el-button @click="deleteModal(scope.row)" type="text" size="small">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <!-- 分页区域 -->
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="searchInfo.pageNum"
                        :page-size="searchInfo.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                    ></el-pagination>
                </el-card>
            </el-col>
        </el-row>
        <!-- 弹框 -->
        <el-dialog
            title="新增专题"
            :visible.sync="addDialogFormVisible"
            width="50%"
            :before-close="handleClose"
            :close-on-click-modal="false"
        >
            <add v-bind:addData="addData" @dialog="dialogForm" ref="add"></add>
        </el-dialog>
        <!-- <el-dialog title="修改专题" :visible.sync="editDialogFormVisible" width="800px" :close-on-click-modal="false">
            <edit v-bind:editData="editData" @dialogEdit="dialogFormEdit"></edit>
        </el-dialog> -->
           <edit ref="edit" @getSysInfoList="getSysInfoList"></edit>
    </div>
</template>
<script>
import add from './subjectChildren/add.vue';
import edit from './subjectChildren/edit.vue';
export default {
    data() {
        return {
            searchInput: '',
            // 查询参数
            searchInfo: {
                // 默认请求第一页
                pageNum: 1,
                // 默认请求10条数据
                pageSize: 10,
                topicName: '', //优惠券名称
                merchantId: ''
            },
            id: '', //商家id
            // 日期
            date: null,
            // 数据列表
            tableData: [],
            // 数据总数
            total: 0,
            addData: '',
            editData: {},
            addDialogFormVisible: false, //新增
            editDialogFormVisible: false //修改
        };
    },
    created() {
        // 获取数据列表
        let that=this
        console.log(that.$route.query);
        that.searchInfo.merchantId = this.$route.query.id;
        that.id = that.$route.query.id;
        console.log(that.id);

        // that.getSysInfoList();
    },
    components: { add ,edit},
    methods: {
        async getSysInfoList() {
            let that=this
            const res = await that.$axios.post('topic/list', that.searchInfo);
            console.log(res);
            if (res.data.code == 0) {
                that.tableData = res.data.data;
                console.log(that.tableData);
                that.total = res.data.total;
            } else {
                that.$message.error(res.data.data);
            }
        },
        //查询
        Search() {
            this.searchInfo.pageNum = 1;
            this.getSysInfoList();
        },
        handleSizeChange(pageSize) {
            this.pageNum = 1;
            this.searchInfo.pageSize = pageSize;
            this.getSysInfoList();
        },

        handleCurrentChange(pageNum) {
            this.searchInfo.pageNum = pageNum;
            this.getSysInfoList();
        },
        //新建
        addModal() {
            this.addData = this.id;
            console.log(this.addData);

            this.addDialogFormVisible = true;
        },
        handleClose() {
            this.$refs.add.resetForm();
        },
        //修改
        editModal(data) {
            let that=this
            console.log(data);
           that.$refs.edit.getMerchantInfo({merchantId:that.id,id:data.id})
            // that.editData.merchantId = this.id;
            // that.editData.id = data.id;
            // console.log(that.editData);
            // that.editDialogFormVisible = true;
        },
        //删除
        deleteModal(data) {
            console.log(data);

            this.$confirm('您确定要删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$axios
                    .post('topic/delete', { id: data.id })
                    .then(res => {
                        if (res.data.code == 0) {
                            this.$message.success('删除成功');
                            this.getSysInfoList();
                        } else {
                            this.$message.error(res.data.data);
                        }
                    })
                    .catch(() => {
                        this.getSysInfoList();
                    });
            });
        },
        dialogFormEdit(data) {
            console.log(data);
            this.editDialogFormVisible = data;
            this.getSysInfoList();
        },
        dialogForm(data) {
            this.addDialogFormVisible = data;
            this.getSysInfoList();
        },
        checkModal(data) {
            console.log(data);
            this.$router.push({
                name: 'subjectCheck',
                query: {
                    id: data.id
                }
            });
        },
        goBack() {
            this.$router.push('/BusManage-Detail');
        }
    }
};
</script>
<style lang="less" scoped>
.el-table {
    margin-top: 20px;
}
.el-pagination {
    margin-top: 20px;
    text-align: center;
}
</style>
